/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import $http from '../plugins/axios';

// import axios from 'axios';

// const BASE_URL = 'http://localhost:3000/local/genome-solidify-api-svc/';

const taskData = async (url: string, data: any) => {
  const res = await $http.post(url, data);
  return res;
};

const registerLearner = async (url: string, data: any) => {
  const res = await $http.post(url, data);
  return res;
};

const getExistedLearner = async (url: string, data: any) => {
  const res = await $http.post(url, data);
  return res;
};
export { taskData, registerLearner, getExistedLearner };
